import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { BlockStyle, BlockWrapperComponent } from 'src/app/storyblok/components/block-wrapper/block-wrapper.component';
import { StoryblokRichTextPipe } from 'src/app/storyblok/storyblok-rich-text.pipe';
import { SvgComponent } from '../../../../shared/components/svg/svg.component';
import { ReplaceTextPipe } from '../../../../storyblok/pipes/replace-text.pipe';
import { ConversionFormat } from '../../templates/conversion-template/conversion-template.component';

@Component({
  selector: 'app-convert-from-format-list',
  standalone: true,
  templateUrl: './convert-from-format-list.component.html',
  styleUrls: ['./convert-from-format-list.component.scss'],
  imports: [
    CommonModule,
    ReplaceTextPipe,
    BlockWrapperComponent,
    StoryblokRichTextPipe,
    RouterLink,
    SvgComponent,
    ButtonDirective,
  ],
})
export class ConvertFromFormatListComponent {
  private route = inject(ActivatedRoute);
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() categories: string[];

  formats$ = this.route.data.pipe(
    map(data => {
      return (<ConversionFormat[]>data.toolConversionFromFormatList || [])
        .filter(format => {
          if (this.categories) {
            return this.categories.includes(format.content.category);
          }
          return true;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    })
  );
}
